var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.sinister.sinisterSinisterNumber))]),_vm._v(" "),_c('tabs',[_c('tab',{attrs:{"name":"Siniestro"}},[_c('general',{attrs:{"roadSinister":_vm.sinister}})],1),_vm._v(" "),_c('tab',{attrs:{"name":"Archivos"}},[_c('files-view',{attrs:{"files":_vm.files,"taxReceip":_vm.taxReceip}})],1),_vm._v(" "),_c('tab',{attrs:{"name":"Bitácora"}},[_c('binnacle',{attrs:{"affected":_vm.sinister.affected.id}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/extranet/SinisterView.vue